import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguageLocal } from 'redux/auth/authSlice';
import { selectIsLoggedIn, selectUserSettings } from 'redux/selectors';
import {
  normalizeLanguageCode,
  resolveInitialLanguage,
  syncI18nLanguage,
} from 'utils/language';

export function useLanguageSync() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const settings = useSelector(selectUserSettings);
  const didBootstrap = useRef(false);
  const lastSynced = useRef(null);

  useEffect(() => {
    if (didBootstrap.current) return;
    didBootstrap.current = true;

    const bootstrap = async () => {
      const lang = resolveInitialLanguage();
      const normalized = normalizeLanguageCode(lang);
      dispatch(setLanguageLocal(normalized));
      await syncI18nLanguage(normalized);
      lastSynced.current = normalized;
    };

    bootstrap();
  }, [dispatch]);

  useEffect(() => {
    if (!settings?.language) return;

    const normalized = normalizeLanguageCode(settings.language);
    if (lastSynced.current === normalized && isLoggedIn) return;

    const sync = async () => {
      await syncI18nLanguage(normalized);
      lastSynced.current = normalized;
    };

    sync();
  }, [settings?.language, isLoggedIn]);
}
